document.addEventListener('variant:change', function (event) {

  const variant = event.detail?.variant;
  if (!variant) return;

  const mediaId = variant?.featured_media?.id;
  if (!mediaId) return;

  const target = document.querySelector(
    `[data-media-id="${mediaId}"]`
  );

  if (!target) return;

  target.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });

});
